import { Download, Loader2 } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface ReportExportButtonProps {
  onExport: () => void;
  label?: string;
  disabled?: boolean;
  busy?: boolean;
}

/** Right-aligned XLSX export trigger, hidden when printing. */
export function ReportExportButton({ onExport, label = 'Excel', disabled, busy }: ReportExportButtonProps) {
  return (
    <div className="flex justify-end print:hidden">
      <Button type="button" variant="outline" size="sm" className="h-8" onClick={onExport} disabled={disabled || busy}>
        {busy ? <Loader2 className="mr-2 h-4 w-4 animate-spin" /> : <Download className="mr-2 h-4 w-4" />}
        {label}
      </Button>
    </div>
  );
}
